import { render, staticRenderFns } from "./InheritModification.vue?vue&type=template&id=b5f1b51c&scoped=true&"
import script from "./InheritModification.vue?vue&type=script&lang=ts&"
export * from "./InheritModification.vue?vue&type=script&lang=ts&"
import style0 from "./InheritModification.vue?vue&type=style&index=0&id=b5f1b51c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f1b51c",
  null
  
)

export default component.exports